import { ActionIcon } from "PFComponents/action_icon";
import { Inline } from "PFComponents/containers";
import { SyntheticEvent } from "react";

export type AccordionHeaderProps = {
  title: string;
  disabled?: boolean;
  restoreTitle?: string;
  clearTitle?: string;
  onClear?: ((event?: SyntheticEvent) => void) | false;
  onRestore?: ((event?: SyntheticEvent) => void) | false;
};

export const AccordionHeader = ({
  title,
  disabled,
  clearTitle,
  restoreTitle,
  onClear,
  onRestore
}: AccordionHeaderProps) => (
  <Inline as="span" justifyContent="space-between" alignItems="center">
    {title}
    <Inline as="span" gap="spacingSm">
      {onRestore && (
        <ActionIcon name="history" size="sm" onClick={onRestore} disabled={disabled} title={restoreTitle} />
      )}
      {onClear && (
        <ActionIcon name="filter-clean" size="sm" onClick={onClear} disabled={disabled} title={clearTitle} />
      )}
    </Inline>
  </Inline>
);
